import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { usePathname, useRouter } from "next/navigation";
import { PuzzlePieceIcon } from "@heroicons/react/24/outline";
import VolumeControl from "@/components/VolumeControl";
import MemoXBare from "@assets/SVG/XBare";
// import MemoMedium from "@assets/SVG/Medium";
import MemoLinkedInBare from "@assets/SVG/LinkedInBare";
import MemoTelegramBare from "@assets/SVG/TelegramBare";
import MemoDiscord from "@assets/SVG/Discord";
// import MemoTikTok from "@assets/SVG/TikTok";
// import MemoInstagram from "@assets/SVG/Instagram";
import MemoLogout from "@assets/SVG/Logout";
import MemoLogo from "@assets/SVG/Logo/logo";
import { useStytch, useStytchUser } from "@stytch/nextjs";
import Link from "next/link";
// import { getFullName } from "@/services/user";

export const UserDropdownModal = ({ setOpen }: { setOpen: Dispatch<SetStateAction<boolean>> }) => {
    const router = useRouter();
    const pathname = usePathname();
    const { user } = useStytchUser();

    // const fullName = getFullName(user?.name);

    const [items, setItems] = useState([
        {
            icon: PuzzlePieceIcon,
            name: "Browser Extension",
        },
        // {
        //     icon: RocketLaunchIcon,
        //     name: "Download Web App",
        // },
        // {
        //     icon: ChatBubbleLeftIcon,
        //     name: "Contact Us",
        // },
    ]);
    const { session } = useStytch();

    useEffect(() => {
        if (session) {
            setItems([
                ...items,
                {
                    icon: MemoLogout as any,
                    name: "Log Out",
                },
            ]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [session]);

    const signOut = () => {
        session.revoke();
    };

    const handleRouting = (item: string) => {
        if (item === "Log Out") {
            signOut();
        }

        if (item === "Contact Us") {
            router.push("/profile/contact-us");
        }
        setOpen(false);
    };

    const socials = [
        {
            href: "https://twitter.com/goblockbeat",
            icon: MemoXBare,
            name: "X",
        },
        // {
        //     href: "https://www.instagram.com/getblockbeat/",
        //     icon: MemoInstagram,
        // },
        // {
        //     href: "https://www.tiktok.com/@getblockbeat",
        //     icon: MemoTikTok,
        // },
        // {
        //     href: "https://getblockbeat.medium.com/",
        //     icon: MemoMedium,
        // },
        {
            href: "https://www.linkedin.com/company/blockbeat/",
            icon: MemoLinkedInBare,
            name: "LinkedIn",
        },
        {
            href: "https://discord.com/invite/VCKB4Ayg8J",
            icon: MemoDiscord,
            name: "Discord",
        },
        {
            href: "https://t.me/+DdibR6Z6Gyo3ZTUx",
            icon: MemoTelegramBare,
            name: "Telegram",
        },
    ];

    return (
        <div
            // onPointerLeave={() => setOpen(false)}
            className="flex w-[max-content] flex-col items-start overflow-hidden rounded-lg border border-midnight-blue bg-royal-blue pb-1"
        >
            <Link
                href="/profile/subscription"
                passHref
                className={`w-full overflow-hidden rounded-lg ${
                    !pathname?.includes("/profile") && "cursor-pointer hover:brightness-75"
                }`}
                legacyBehavior
            >
                <a
                    // onClick={() => setShow(false)}
                    className="w-full cursor-pointer items-center hover:brightness-75"
                >
                    <div className="flex w-full items-center gap-2 border-b border-dark-blue bg-dark-blue p-2">
                        <MemoLogo className="size-6" />
                        <div className="flex flex-col items-start p-0">
                            <div className="flex items-center gap-1 p-0">
                                <p className="w-40 truncate text-xs font-normal">{user?.emails[0]?.email}</p>
                                <div className="flex h-3 items-center justify-center rounded-2xl bg-light-red px-1 py-0">
                                    <p className="text-[10px] font-light uppercase leading-3 text-white">
                                        BETA
                                    </p>
                                </div>
                            </div>
                            <p className="text-xs font-light text-neutral">@BlockBeat</p>
                        </div>
                    </div>
                </a>
            </Link>
            <div className="flex w-full flex-col items-start px-0 py-1">
                <VolumeControl />

                <div className="my-1 flex w-full border-t border-dark-blue" />

                {items.slice(0, 2).map((item, i) => (
                    <a
                        href={
                            item.name === "Browser Extension"
                                ? "https://chrome.google.com/webstore/detail/blockbeat-crypto-hover/cgkdbhlfmjiglkhcdjjmfbajmddenihi"
                                : (null as any)
                        }
                        target={item.name === "Browser Extension" ? "_blank" : ""}
                        key={i}
                        onClick={() => handleRouting(item.name)}
                    >
                        <div className="flex w-full cursor-pointer items-center gap-2 p-2 text-neutral hover:brightness-75">
                            <item.icon className="size-4" />
                            <p className="text-xs font-light">{item.name}</p>
                        </div>
                    </a>
                ))}

                <div className="my-1 flex w-full border-t border-dark-blue" />
                <div className="flex w-full justify-center gap-3 pt-1">
                    {socials?.map((social) => (
                        <a
                            key={social.href}
                            className="flex size-5 cursor-pointer items-center justify-center rounded-full bg-steel-blue bg-none hover:bg-powder-blue"
                            href={social.href}
                            target="_blank"
                        >
                            {social.name === "X" ? (
                                <social.icon className="size-4" />
                            ) : (
                                <social.icon className="size-3 text-white" color="#FFFFFF" />
                            )}
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};
